import React from 'react'
import Icon from './Icon'

const Mail = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <path
          d="M0.309,10.538 L23.15,1.104 L8.621,14.695 L0.319,11.466 C0.128,11.392 0.002,11.21 7.21644966e-16,11.007 C-0.002,10.801 0.12,10.616 0.309,10.538 Z M9.01,15.7 L23.966,1.71 L19.988,20.105 C19.955,20.261 19.851,20.39 19.707,20.455 C19.57,20.518 19.401,20.517 19.259,20.437 L13.219,17.116 L9.932,22.752 C9.841,22.908 9.674,23 9.5,23 C9.221,23 9,22.774 9,22.5 L9,15.69 L9.01,15.7 Z"
          fill="#FFFFFF"
          fillRule="nonzero"
        />
      </g>
    </g>
  </Icon>
)

export default Mail



// WEBPACK FOOTER //
// ./icons/Mail.js